import { ICoreContext } from '@msdyn365-commerce/core-internal';
import { MTT_HIDE_ADD_TO_CART_FOR_GUESTS, MTT_HIDE_PRICES_FOR_GUESTS } from '../constants';
import { getBooleanProperty } from './extension-properties-helpers';

export const shouldHidePricesFromUI = (context: ICoreContext): boolean => {
    const isGuest = !context.actionContext.requestContext.user.isAuthenticated;
    const extensionProperties = context.request.channel?.ExtensionProperties;

    return isGuest && getBooleanProperty(extensionProperties, MTT_HIDE_PRICES_FOR_GUESTS);
};

export const shouldHideAddToCartFromUI = (context: ICoreContext): boolean => {
    const isGuest = !context.actionContext.requestContext.user.isAuthenticated;
    const extensionProperties = context.request.channel?.ExtensionProperties;

    return isGuest && getBooleanProperty(extensionProperties, MTT_HIDE_ADD_TO_CART_FOR_GUESTS);
};
